import { MetricaScript } from "@kupikupi/analytics/react";
import { DEFAULT_LOCALE, YM_COUNTER_ID } from "@kupikupi/brand";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthBootstrap } from "./components/AuthBootstrap";
import { BackendLangBridge } from "./components/BackendLangBridge";
import { initI18n } from "./i18n";
import { initMockTelegram } from "./lib/mock-tg-env";
import { router } from "./router";
import { initTelegram } from "./telegram";
import "./main.css";

async function bootstrap() {
  initMockTelegram();
  initTelegram();
  await initI18n(DEFAULT_LOCALE as "ru" | "zh");

  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
  });

  const root = document.getElementById("root");
  if (!root) throw new Error("#root not found");
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthBootstrap>
          <BackendLangBridge>
            <MetricaScript counterId={YM_COUNTER_ID} />
            <RouterProvider router={router} />
          </BackendLangBridge>
        </AuthBootstrap>
      </QueryClientProvider>
    </StrictMode>,
  );
}

bootstrap();
